import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './services/auth';
import Sidebar     from './components/common/Sidebar';
import Login       from './pages/Login';
import Register    from './pages/Register';
import Dashboard   from './pages/Dashboard';
import Deployments from './pages/Deployments';
import Clouds      from './pages/Clouds';
import Costs       from './pages/Costs';
import Optimizer   from './pages/Optimizer';
import Monitor     from './pages/Monitor';
import Settings    from './pages/Settings';
import Invoice from './pages/Invoice';
import Integrations from './pages/Integrations';
import Servers from './pages/Servers';
import ServerGroups from './pages/ServerGroups';
import ResetPassword from './pages/ResetPassword';
import AcceptInvite from './pages/AcceptInvite';
import UpgradeLimitModal from './components/common/UpgradeLimitModal';
import AIAssistant from './components/common/AIAssistant';
import { applyStoredTheme } from './components/common/ThemeSwitcher';
import NightVisionEngine from './components/common/NightVisionEngine';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading"><div className="spinner"/></div>;
  return user ? children : <Navigate to="/login" />;
};

const AppLayout = ({ children }) => (
  <div className="app-layout">
    <Sidebar />
    <div className="main-content">
      <div className="page-content fade-in">{children}</div>
    </div>
    <AIAssistant />
    <NightVisionEngine />
  </div>
);

const App = () => (
  <AuthProvider>
    <BrowserRouter>
      <UpgradeLimitModal />
      <Routes>
        <Route path="/login"    element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/accept-invite/:orgId/:token" element={<AcceptInvite />} />
        <Route path="/" element={<PrivateRoute><AppLayout><Dashboard /></AppLayout></PrivateRoute>} />
        <Route path="/deployments" element={<PrivateRoute><AppLayout><Deployments /></AppLayout></PrivateRoute>} />
        <Route path="/clouds"      element={<PrivateRoute><AppLayout><Clouds /></AppLayout></PrivateRoute>} />
        <Route path="/costs" element={<PrivateRoute><AppLayout><Costs /></AppLayout></PrivateRoute>} />
          <Route path="/invoice" element={<PrivateRoute><AppLayout><Invoice /></AppLayout></PrivateRoute>} />
        <Route path="/optimizer"   element={<PrivateRoute><AppLayout><Optimizer /></AppLayout></PrivateRoute>} />
        <Route path="/monitor"     element={<PrivateRoute><AppLayout><Monitor /></AppLayout></PrivateRoute>} />
        <Route path="/servers" element={<PrivateRoute><AppLayout><Servers /></AppLayout></PrivateRoute>} />
        <Route path="/server-groups" element={<PrivateRoute><AppLayout><ServerGroups /></AppLayout></PrivateRoute>} />
        <Route path="/integrations" element={<PrivateRoute><AppLayout><Integrations /></AppLayout></PrivateRoute>} />
        <Route path="/settings"    element={<PrivateRoute><AppLayout><Settings /></AppLayout></PrivateRoute>} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  </AuthProvider>
);

export default App;
